import { ClassificationSettingsFlags } from '@kentik/ui-shared/types/interfaceClassification';

export interface RuleMatched {
  id: string | number;
  didClassify?: boolean;
  rank?: number;
}

export interface InterfaceJson {
  [key: string]: unknown;
  id: string;
  device_id: string;
  device_name: string;
  connectivity_type: string;
  initial_connectivity_type: string;
  network_boundary: string;
  initial_network_boundary: string;
  rules_matched?: RuleMatched[];
}

export interface DeviceCount {
  device_id: number;
  total_interfaces: number;
  classified_interfaces: number;
  classified_ratio?: string;
}

export interface RuleCount {
  rule_id: string;
  total_interfaces_count: number;
}

export interface RuleInterface {
  interface_details: object;
  device_id: string;
}

export interface EvaluationResult {
  device_id: string;
  matchInfo: { interfaceCount?: number; interfacesClassifiedCount?: number; rulesUsed?: number };
  rules: { id: number; interfacesMatched: object[]; interfacesClassified: object[] }[];
  interfaces: {
    id: string;
    device_id: string;
    device_name: string;
    connectivity_type: string;
    initial_connectivity_type: string;
    network_boundary: string;
    initial_network_boundary: string;
    rules_matched: RuleMatched[];
  }[];
}

export const isEvaluationResult = (data: unknown): data is EvaluationResult =>
  !!(
    data &&
    typeof data === 'object' &&
    'device_id' in data &&
    'matchInfo' in data &&
    'rules' in data &&
    'interfaces' in data
  );

interface CompleteType {
  complete: true;
}

export const isCompleteType = (data: unknown): data is CompleteType =>
  !!(data && typeof data === 'object' && 'complete' in data && data.complete);

interface TotalDevicesType {
  totalDevices: number;
}

export const isTotalDevices = (data: unknown): data is TotalDevicesType =>
  !!(
    (data && typeof data === 'object' && 'totalDevices' in data)
    // TODO check this assumption, for now this is left out for legacy compatibility
    //    && typeof data.totalDevices === 'number'
  );

interface BatchedEvaluationData {
  batching: boolean;
  batchIndex: number;
  batchSize: number;
  aggregateMode?: boolean;
  phase?: string;
  results: EvaluationResult[];
}

export const isBatchedEvaluationResult = (data: unknown): data is BatchedEvaluationData =>
  !!(
    data &&
    typeof data === 'object' &&
    'batching' in data &&
    data.batching &&
    'batchIndex' in data &&
    'batchSize' in data &&
    'results' in data &&
    Array.isArray(data.results)
  );

export interface InterfaceSettingsJson {
  [key: string]: unknown;
  id: string;
  settings: ClassificationSettingsFlags;
}
